import axios from 'axios';
import { getApiUrl, parseMgkResponse } from '@/config/api';

const BASE = '/api/Asistencia';
const rows = data => Array.isArray(data?.OData) ? data.OData : (Array.isArray(data) ? data : []);

export default {
  async eventos() {
    const r = await axios.post(getApiUrl(`${BASE}/eventos`), {});
    return rows(r.data);
  },
  async turnos(filtro = {}) {
    const r = await axios.post(getApiUrl(`${BASE}/turnos/listar`), filtro);
    return rows(r.data);
  },
  async asignarTurnos(model) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/turnos/asignar`), model));
  },
  async registros(filtro = {}) {
    const r = await axios.post(getApiUrl(`${BASE}/registros/listar`), filtro);
    return rows(r.data);
  },
  async guardarRegistro(model) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/registros/guardar`), model));
  },
  async anularRegistro(model) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/registros/anular`), model));
  },
  async importar(model) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/registros/importar`), model));
  },
  async jornadas(filtro = {}) {
    const r = await axios.post(getApiUrl(`${BASE}/jornadas/listar`), filtro);
    return rows(r.data);
  },
  async recalcular(filtro) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/jornadas/recalcular`), filtro));
  },
  async miEstado() {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/mi-asistencia/estado`), {}));
  },
  async miHistorial(filtro = {}) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/mi-asistencia/historial`), filtro));
  },
  async miRegistrar(model = {}) {
    return parseMgkResponse(await axios.post(getApiUrl(`${BASE}/mi-asistencia/registrar`), model));
  }
};
